import * as React from "react";

// importing material UI components
import { useState } from "react";
import FileUploadLogsTable from "./FileUploadLogsTable";
import Container from "@mui/material/Container";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import Box from "@mui/material/Box";
import { ColorsConstants } from "../../cssUtils/constants";
import typography from "../../cssUtils/typography";
import AppDatePicker from "../../common/app-date-picker"


const FileUploadLogs = (props) => {
  const [value, setValue] = useState(null);
  const [datetimeArray, setDateTimeArray] = useState(["year", "month", "day"]);
  const [cleared, setCleared] = useState(false);

  const handleDateChange = (newDate) => {
    setValue(newDate);
  };

  return (
    <div className="App">
      <Container maxWidth={false}>
        
        <Box
          className="upload-date-picker-div"
          sx={{
            display: "flex",
            alignItems: {xs: "flex-start", md: "center"},
            gap: {xs: 2, md: "15px"},
            flexDirection: { xs: "column", md: "row" },
            mt: 4
          }}
        >
          <p style={{...typography.h2, margin: 0, color: ColorsConstants.primaryBackgroundColor }}>File Upload Logs</p>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
            <AppDatePicker
              value={value}
              onChange={(newValue) => handleDateChange(newValue)}
              disableFuture
              views={datetimeArray}
              sx={{ width: { xs: "100%", md: 260 } }}
              slotProps={{
                field: { clearable: true, onClear: () => setCleared(true) },
              }}
            />
            </LocalizationProvider>
        </Box>
        <FileUploadLogsTable key={props.refreshKey} dateInput={value} />
      </Container>
    </div>
  );
};
export default FileUploadLogs;
